(function() {
  'use strict';

  window.ModalFieldsController = function($formElem, $fields) {
    this._$form_elem = $formElem;
    this._$fields = $fields;
    this._$required_fields = this._getRequiredFields();
    this._$submit = null;

    this._addFormSubmitEventListener();
  };

  ModalFieldsController.prototype._getRequiredFields = function() {
    return this._$fields.get().filter(isRequiredFieldFilter)
  };

  function isRequiredFieldFilter($elem) {
    return typeof $elem.dataset.modalRequired !== 'undefined'
  }

  ModalFieldsController.prototype._addFormSubmitEventListener = function() {
    this._$form_elem.submit(this._onSubmit.bind(this));
  };

  ModalFieldsController.prototype._onSubmit = function(e) {
    if (!this._canSubmit()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      this._displayModalForm()
    }
  };

  ModalFieldsController.prototype._canSubmit = function() {
    return this._areRequiredValuesPresent()
  };

  ModalFieldsController.prototype._areRequiredValuesPresent = function() {
    return this._$required_fields.every(requiredValueIsPresent)
  };

  function requiredValueIsPresent(field) {
    return $(field).find('input').val()
  }

  ModalFieldsController.prototype._displayModalForm = function() {
    modals.getModalHeader().empty();
    modals
      .getModalBodyAndFooter()
      .empty()
      .append(this._createModalBody())
      .append(this._createModalFooter());

    this._updateSubmitButtonState();
    this._addFieldEventListeners();

    modals.getModal().modal({ areYouSure : false, backdrop : false });
  };

  ModalFieldsController.prototype._createModalBody = function() {
    return $('<div>').addClass('modal-body').append(
      createInfoElement(), bootstrap.show(this._$fields));
  };

  function createInfoElement() {
    return $('<div>')
      .addClass('m-b-20')
      .text('Please provide the following information before continuing:')
  }

  ModalFieldsController.prototype._createModalFooter = function() {
    return $('<div>').addClass('modal-footer').append(
      this._getSubmitButton(), this._createCancelButton())
  };

  ModalFieldsController.prototype._createCancelButton = function() {
    return dom.createButton('danger', 'close', 'Close').click(hideModal)
  };

  function hideModal() {
    modals.getModal().modal('hide');
  }

  ModalFieldsController.prototype._getSubmitButton = function() {
    if (this._$submit == null) {
      this._$submit = this._createSubmitButton();
    }

    return this._$submit;
  };

  ModalFieldsController.prototype._createSubmitButton = function() {
    return dom.createButton('primary', 'check-all', 'Save').click(this._onSubmitClick.bind(this))
  };

  ModalFieldsController.prototype._onSubmitClick = function() {
    if (this._areRequiredValuesPresent()) {
      this._hideModalAndSubmit();
    }
  };

  ModalFieldsController.prototype._hideModalAndSubmit = function() {
    modals.getModal().one('hidden.bs.modal', this._submitForm.bind(this));
    hideModal();
  };

  ModalFieldsController.prototype._submitForm = function() {
    this._restoreElements();
    this._$form_elem.submit();
  };

  ModalFieldsController.prototype._restoreElements = function() {
    this._$form_elem.append(bootstrap.hide(this._$fields))
  };

  ModalFieldsController.prototype._addFieldEventListeners = function() {
    var fn = this._updateSubmitButtonState.bind(this);
    this._$fields.on('keydown', fn).click(fn);
  };

  ModalFieldsController.prototype._updateSubmitButtonState = function(e) {
    if (this._canSubmit()) {
      this._getSubmitButton().removeAttr('disabled');
      this._handleEnterKeyDownEvent(e);
    } else {
      this._getSubmitButton().attr('disabled', true)
    }
  };

  ModalFieldsController.prototype._handleEnterKeyDownEvent = function(e) {
    if (userPressedEnterKey(e.type, e.keyCode)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      this._hideModalAndSubmit();
    }
  };

  function userPressedEnterKey(type, keycode) {
    return type === 'keydown' && keycode === 13
  }
})();
